let callbacks = [];

$(document).on('update@elkitorg', function (e, $context) {
	callbacks.forEach(callback => {
		try {
			callback($context);
		} catch (e) {
			console.error(e);
		}
	});
});

export default (callback) => {
	callbacks.push(callback);
};